module.exports = __webpack_public_path__ + "img/activecommunity.0213a530.svg";